import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Head from "next/head";
import React from "react";
import AuthHeader from "../../../pages/AuthHeader/AuthHeader";
import Footer from "../../molecules/Footer/Footer";
import styles from "./BasicHtmlContent.module.css";

var BasicHtmlContent = function BasicHtmlContent(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: title
      })
    }), /*#__PURE__*/_jsx(AuthHeader, {}), /*#__PURE__*/_jsx("div", {
      className: styles.container_body,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.container,
        children: children
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};

export default BasicHtmlContent;